/**
 * AGRIKO COLLECTIONS — Agricultural Almanac Scroll Reveal
 * =========================================================
 *
 * Fallback scroll reveal animations for browsers that don't support
 * the CSS View Timeline API (animation-timeline: view()).
 *
 * Uses IntersectionObserver to add .is-visible class to elements
 * as they enter the viewport.
 *
 * No dependencies — vanilla JS with minimal overhead.
 */

(function() {
  'use strict';

  // Check if browser supports CSS View Timeline API
  const supportsViewTimeline = CSS.supports('animation-timeline: view()');

  // Exit early if browser has native support
  if (supportsViewTimeline) {
    return;
  }

  /**
   * Initialize scroll reveal observer
   */
  function initScrollReveal() {
    // Elements to animate
    const selectors = [
      '.template-collection .ag-card',
      '.template-collection .ag-product-grid__item',
      '.template-collection .ag-collection-section__intro'
    ];

    const elements = document.querySelectorAll(selectors.join(', '));

    if (elements.length === 0) {
      return;
    }

    // Intersection Observer options
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    };

    // Create observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          // Add slight stagger based on position
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, index * 50);

          // Stop observing once visible
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe all elements
    elements.forEach(el => observer.observe(el));
  }

  /**
   * Add catalog numbers to product cards
   * Optional enhancement for archival feel
   */
  function addCatalogNumbers() {
    const productCards = document.querySelectorAll(
      '.template-collection .ag-product-grid__item .ag-card'
    );

    productCards.forEach((card, index) => {
      // Skip if already has catalog number
      if (card.querySelector('.ag-card__catalog-number')) {
        return;
      }

      // Generate catalog number: AG-001, AG-002, etc.
      const catalogNum = `AG-${String(index + 1).padStart(3, '0')}`;

      // Create badge element
      const badge = document.createElement('span');
      badge.className = 'ag-card__catalog-number';
      badge.textContent = catalogNum;
      badge.setAttribute('aria-hidden', 'true');

      // Insert after media wrapper
      const mediaWrapper = card.querySelector('.ag-card__media-wrapper, .ag-card__image-container');
      if (mediaWrapper) {
        mediaWrapper.style.position = 'relative';
        mediaWrapper.appendChild(badge);
      }
    });
  }

  /**
   * Initialize when DOM is ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initScrollReveal();
      // Uncomment below to enable catalog numbers:
      // addCatalogNumbers();
    });
  } else {
    initScrollReveal();
    // Uncomment below to enable catalog numbers:
    // addCatalogNumbers();
  }

  /**
   * Cleanup on page hide
   */
  window.addEventListener('pagehide', () => {
    // Disconnect any observers if we were tracking them
  });

})();
